module.exports = __webpack_public_path__ + "static/img/brees-2018-top-image-thumb.a64c482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2018-top-image-thumb.jpg
// module id = /H0G
// module chunks = 1